/* eslint-disable */
/**
 * This file was automatically generated by json-schema-to-typescript.
 * DO NOT MODIFY IT BY HAND. Instead, modify the source JSONSchema file,
 * and run json-schema-to-typescript to regenerate this file.
 */

export type Option = string[];
export type OptionWithLabel = {
  key?: string;
  value?: string;
  [k: string]: unknown;
}[];
export type RegistrationFieldsMasterData = RegistrationValidations[];

export interface RegistrationValidations {
  pk: string;
  fieldName?: string;
  options?: Options;
  validations?: ValidationsForType;
  optionsWithLabels?: OptionWithLabelObj;
  executionStep?: string;
  fieldType?: FieldType;
  loggedInUserPrimaryContact?: string;
  COAPP?: { validations?: ValidationsForType };
  [k: string]: unknown;
}

export const enum FieldType {
  INPUT = 'INPUT',
  CALENDER = 'CALENDAR',
  CHECKBOX = 'CHECKBOX',
  CUSTOM = 'CUSTOM',
  FILE = 'FILE',
  DYNAMIC = 'DYNAMIC',
}
export interface Options {
  ALL?: Option;
  BUSINESS_OWNER?: Option;
  MEMBER?: Option;
  [k: string]: unknown;
}

export interface DropDownOptions {
  ALL?: Option[];
  BUSINESS_OWNER?: Option[];
  MEMBER?: Option[];
  [k: string]: unknown;
}
export interface ValidationsForType {
  ALL?: FieldValidations;
  BUSINESS_OWNER?: FieldValidations;
  MEMBER?: FieldValidations;
  EMPLOYEE?: FieldValidations;
}
export interface FieldValidations {
  required?: boolean;
  min?: number;
  max?: number;
  regex?: string;
  length?: number;
  visible?: boolean;
  fieldType?: FieldType;
  ageCalAtyearEnd?: boolean;
  doNotKnowSponsorFlow?: string;
}
export interface OptionWithLabelObj {
  ALL?: OptionWithLabel;
  BUSINESS_OWNER?: OptionWithLabel;
  MEMBER?: OptionWithLabel;
  [k: string]: unknown;
}
